import { faEnvelope, faHome, faPhone } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import './ContactUs.css';

const ContactUs = () => {
    return (
        <section className="contactUs-wrapper">
            <Container>
                <Row>
                    <Col md={6} lg={6} xl={4}>
                        <div className="single-contact icon1">
                            <div className="c-icon">
                                <FontAwesomeIcon icon={faHome} />
                            </div>
                            <div className="c-info text-start">
                                <h4>Address</h4>
                                <p>Near Laxmi Mata Mandir, Mahadev Nagar</p>
                                <p>Hingane Khurd, Sinhagad Road, Pune - 411051</p>
                            </div>
                        </div>
                    </Col>
                    <Col md={6} lg={6} xl={4}>
                        <div className="single-contact icon2">
                            <div className="c-icon">
                                <FontAwesomeIcon icon={faEnvelope} />
                            </div>
                            <div className="c-info text-start">
                                <h4>Email</h4>
                                <p>savalioldage@gmail.com</p>
                                
                            </div>
                        </div>
                    </Col>
                    <Col md={6} lg={6} xl={4}>
                        <div className="single-contact icon3">
                            <div className="c-icon">
                                <FontAwesomeIcon icon={faPhone} />
                            </div>
                            <div className="c-info text-start">
                                <h4>Phone</h4>
                                <p>(+91) 8668529894</p>
                                <p>(+91) 8830989623</p>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col md={12} lg={12} xl={12}>
                        <div style={{margin:"80px"}}  />
                        <div style={{margin:"20px"}}>
                            <div style={{margin:"50px"}}><strong><h2>Location:</h2></strong></div>
                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d946.0492580732925!2d73.82940328805653!3d18.47473227120001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc295b9812d5ac3%3A0x76f8c9ad70085de1!2sSavali%20Old%20Age%20Care%20and%20Elderly%20Recovery%20Center!5e0!3m2!1sen!2sin!4v1675763131141!5m2!1sen!2sin"
                                width="100%" 
                                height="200%" 
                                title='Location'
                                style={{border:0}} 
                                allowfullscreen="" 
                                loading="lazy" 
                                referrerpolicy="no-referrer-when-downgrade">                                    
                            </iframe>   
                        </div>                 
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default ContactUs;